import { render, staticRenderFns } from "./add-portfolio.vue?vue&type=template&id=0e6eb63e&lang=pug&"
import script from "./add-portfolio.vue?vue&type=script&lang=js&"
export * from "./add-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports